import utils from '../utils';

describe('utils', () => {
  test('it should have proper object properties', () => {
    expect(utils).toHaveProperty('findItemByUuid');
    expect(utils).toHaveProperty('getJsonFromUrl');
    expect(utils).toHaveProperty('substr');
  });
});
